<template>
  <BaseDataList
    ref="dataList"
    :items="accProductTemplates"
    :service="fetchAccProductTemplates"
    allow-search
  >
    <template #header>
      <ListHeader />
    </template>

    <template #default="{ item }">
      <ListItem :acc-product-template="item" />
    </template>
  </BaseDataList>
</template>

<script>
import ListHeader from './list-header.vue';
import ListItem from './list-item.vue';

export default {
  components: {
    ListHeader,
    ListItem,
  },
  data() {
    return {
      lastQuery: {},
    };
  },
  computed: {
    accProductTemplates() {
      return this.$store.getters['admin/accProductTemplates/items'];
    },
  },
  destroyed() {
    this.$store.commit('admin/accProductTemplates/setIds', []);
    this.$store.commit('admin/accProductTemplates/setMeta', null);
    this.$store.commit('admin/accProductTemplates/setLinks', null);
  },
  methods: {
    resetList() {
      this.$refs.dataList.resetList();
    },
    async fetchAccProductTemplates(query = {}) {
      try {
        const response = await this.$store.dispatch('admin/accProductTemplates/load', {
          query,
        });

        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
